
export class MarcacionModel {

    idPerson = '';
    idEvento = '';
    status = '';
    jugo = false;
    constructor(innIdPerson: string, innIdEvento: string, innStatus: string, jugo: boolean) {
        this.idPerson = innIdPerson;
        this.idEvento = innIdEvento;
        this.status = innStatus;
        this.jugo = jugo;
    }//
}//

/*{
    "idPerson": "1312617341",
    "idEvento": "Com_Prin",
    "status": "SIN VALE"
}*/